<template>
  <v-container fluid>
    <!-- Header -->
    <v-row class="mt-n7" no-gutters justify="center">
      <span style="font-size: 34px; color: #616161">
        <v-icon large class="pr-1 pb-2">autorenew</v-icon>
        Salidas de inventario
      </span>
    </v-row>

    <!-- Header Filters -->
    <HeaderFilters
      v-if="showHeader"
      :show_parents="false"
      @refreshWarehouse="getAdjustments"
      :filter_default="defaultFilters"
      :show_all_option="true"
      :show_date_start="true"
    />

    <!-- Main Content -->
    <v-layout align-start>
      <v-flex>
        <v-card flat>
          <v-card-text>
            <!-- Adjustments Table -->
            <v-card outlined class="mt-2 pt-2">
              <v-card-text class="pa-0">
                <v-data-table
                  :headers="headerArticle"
                  :search="search"
                  :items="adjustments"
                  item-key="id"
                  :items-per-page="10"
                  :footer-props="{ itemsPerPageOptions: [10, 20, 30, 40, 50] }"
                >
                  <!-- Table toolbar -->
                  <template v-slot:top>
                    <v-toolbar flat>
                      <v-toolbar-title>Salidas</v-toolbar-title>
                      <v-divider class="mx-4" inset vertical></v-divider>
                      <span>{{ adjustments.length }}</span>
                      <v-spacer></v-spacer>

                      <!-- Search field -->
                      <v-text-field
                        class="text-xs-center"
                        v-model="search"
                        append-icon="search"
                        label="Buscar"
                        single-line
                        hide-details
                        outlined
                        dense
                      ></v-text-field>

                      <v-spacer></v-spacer>

                      <!-- New button -->
                      <v-btn
                        v-if="hasFeature('INV-142')"
                        color="success"
                        class="mr-2"
                        outlined
                        @click="newAdjustment()"
                      >
                        Nuevo
                        <v-icon>add</v-icon>
                      </v-btn>
                    </v-toolbar>
                  </template>

                  <!-- ID column template -->
                  <template v-slot:[`item.id`]="{ item }">
                    <v-hover v-slot="{ hover }">
                      <span
                        @click="viewOutflow(item.id)"
                        class="primary--text font-weight-normal text-truncate font-weight-semibold"
                        :style="{
                          color: hover ? 'red' : 'black',
                          cursor: hover ? 'pointer' : '',
                          'text-decoration': hover ? 'underline' : '',
                        }"
                      >
                        {{ filLeft(item.id.toString(), 12, "0") }}
                      </span>
                    </v-hover>
                  </template>

                  <!-- Effective date column template -->
                  <template v-slot:[`item.effective_date`]="{ item }">
                    {{ formatDate(item.effective_date) }}
                  </template>

                  <!-- Show column template -->
                  <template v-slot:[`item.show`]="{ item }">
                    <v-btn icon small @click="viewOutflow(item.id)">
                      <v-icon>visibility</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>

                <!-- Total card -->
              </v-card-text>
            </v-card>
          </v-card-text>
        </v-card>

        <!-- Main Dialog - MEJORADO -->
        <v-dialog v-model="dialogAdjunct" fullscreen persistent>
          <v-card outlined color="#F4F5FB">
            <!-- Dialog Header -->
            <v-card-title class="py-3">
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    @click="showBar = !showBar"
                    v-click-outside="onClickOutside"
                    color="primary"
                    outlined
                    class="mr-3"
                  >
                    <v-icon>{{ showBar == false ? "menu" : "menu_open" }}</v-icon>
                  </v-btn>
                </template>
                <span>{{ showBar == false ? "Ver menu" : "Ocultar menu" }}</span>
              </v-tooltip>

              <v-spacer></v-spacer>

              <v-btn
                v-show="$route.params.id != undefined"
                small
                @click="backToInventoryValue()"
                color="primary"
                outlined
                class="mr-3"
              >
                <v-icon>keyboard_backspace</v-icon>
                Volver
              </v-btn>

              <span :style="`color:#757575;font-size:20px`">{{ dialogTitle }}</span>

              <v-btn icon @click="print()">
                <v-icon>print</v-icon>
              </v-btn>

              <v-spacer></v-spacer>

              <v-btn
                icon
                @click="(dialogAdjunct = false), ($route.params.id = undefined)"
              >
                <v-icon>clear</v-icon>
              </v-btn>
            </v-card-title>

            <v-card-text>
              <v-divider class="mx-2" inset></v-divider>
              <NavigationButonsTop :showBar="showBar" />

              <!-- Main Content Card - MEJORADO -->
              <v-card outlined elevation="2">
                <v-container fluid>
                  <!-- Comment Section for New Adjustment -->
                  <v-row v-if="isNewAdjustment" justify="center" class="mt-n4">
                    <v-col cols="12" md="8">
                      <v-textarea
                        v-model="note"
                        outlined
                        label="Comentario *"
                        rows="1"
                        hint="Describe el motivo de esta salida de inventario"
                        persistent-hint
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-autocomplete
                        v-model="employeeSelected"
                        :items="employeeItems"
                        :search-input.sync="employeeSearch"
                        :loading="loadingEmployees"
                        :loading-text="'Buscando empleados...'"
                        :no-data-text="
                          employeeSearch && employeeSearch.length > 2
                            ? 'No se encontraron empleados'
                            : 'Escriba al menos 3 caracteres'
                        "
                        dense
                        hide-details
                        item-text="full_name"
                        item-value="id"
                        outlined
                        label="Responsable"
                        return-object
                        clearable
                        :cache-items="false"
                        @input="onEmployeeSelected"
                        @update:search-input="searchEmployees"
                        @click="clearOldSearch"
                        :menu-props="{
                          contentClass: 'elevation-3',
                          closeOnContentClick: true,
                        }"
                        class="employee-autocomplete"
                      >
                        <template v-slot:progress>
                          <div class="loading-text">Buscando empleados...</div>
                        </template>
                        <template v-slot:item="{ item }">
                          <v-list-item-content>
                            <v-list-item-title>{{ item.full_name }}</v-list-item-title>
                            <v-list-item-subtitle v-if="item.department">{{
                              item.department
                            }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>

                  <!-- Articles Table - NUEVA IMPLEMENTACIÓN -->
                  <v-row justify="center">
                    <v-col cols="12">
                      <v-card outlined elevation="1">
                        <v-card-title class="py-3 primary white--text">
                          <v-icon left color="white">list_alt</v-icon>
                          Artículos Seleccionados
                          <v-spacer />
                          <v-btn
                            small
                            @click="dialogItems = true"
                            color="white"
                            outlined
                            class="mr-3"
                          >
                            <v-icon>add_circle_outline</v-icon>
                            Agregar Artículo
                          </v-btn>
                        </v-card-title>

                        <v-data-table
                          :headers="adjustmentHeaders"
                          :items="adjustmentDetails"
                          item-key="item_id"
                          hide-default-footer
                          disable-pagination
                          class="elevation-0"
                        >
                          <!-- Article name template -->
                          <template v-slot:[`item.name`]="{ item }">
                            <div class="d-flex align-center">
                              <v-avatar size="32" color="primary" class="mr-3">
                                <v-icon color="white" small>inventory_2</v-icon>
                              </v-avatar>
                              <div>
                                <div class="font-weight-medium">{{ item.name }}</div>
                                <div class="caption grey--text">
                                  ID: {{ item.item_id }}
                                </div>
                              </div>
                            </div>
                          </template>

                          <!-- Current quantity template -->
                          <template v-slot:[`item.old_quantity`]="{ item }">
                            <v-chip
                              small
                              color="blue-grey lighten-4"
                              text-color="blue-grey darken-2"
                            >
                              <v-icon left small>inventory</v-icon>
                              {{ item.old_quantity }}
                            </v-chip>
                          </template>

                          <!-- New quantity template -->
                          <template v-slot:[`item.new_quantity`]="{ item }">
                            <v-text-field
                              v-model="item.new_quantity"
                              type="number"
                              :max="item.old_quantity"
                              @input="item.new_quantity = parseFloat($event) || 0"
                              dense
                              outlined
                              hide-details
                              style="max-width: 120px"
                              :rules="[
                                (v) =>
                                  v <= item.old_quantity ||
                                  'No puede exceder la cantidad actual',
                              ]"
                            ></v-text-field>
                          </template>

                          <!-- Location template -->
                          <template v-slot:[`item.warehouseInfo`]="{ item }">
                            <v-chip
                              small
                              color="orange lighten-4"
                              text-color="orange darken-2"
                            >
                              <v-icon left small>location_on</v-icon>
                              {{ item.warehouseInfo?.warehouse_name || "N/A" }}
                            </v-chip>
                          </template>

                          <!-- Department template -->
                          <template v-slot:[`item.department_id`]="{ item }">
                            <v-autocomplete
                              v-model="item.department_id"
                              :items="departments"
                              item-text="department_name"
                              item-value="id"
                              dense
                              outlined
                              hide-details
                              style="min-width: 150px"
                              :readonly="!isNewAdjustment"
                            >
                            </v-autocomplete>
                          </template>

                          <!-- Actions template -->
                          <template
                            v-slot:[`item.actions`]="{ item }"
                            v-if="isNewAdjustment"
                          >
                            <v-btn
                              icon
                              color="error"
                              @click="removeItem(item)"
                              :disabled="!isNewAdjustment"
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-card>
                    </v-col>
                  </v-row>

                  <!-- Empty State -->

                  <!-- Save Button -->
                  <v-row
                    v-if="isNewAdjustment && adjustmentDetails.length > 0"
                    class="mt-4"
                  >
                    <v-col cols="12" class="text-right">
                      <v-btn large color="success" @click="saveAdjustment" class="px-8">
                        <v-icon left>save</v-icon>
                        Guardar Salida
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>

    <!-- Articles Catalogue Dialog -->
    <v-dialog
      v-if="$store.state.app.filters.location != null"
      width="auto"
      v-model="dialogItems"
    >
      <articles_catalogue
        v-if="refresArticles && dialogItems"
        @selected-item="addItem"
        :removeItemSelected="false"
        :data="{
          location: $store.state.app.filters.location.value,
          business: $store.state.app.filters.business,
          warehouse: filters.warehouse.id,
          catalogue: filters.location.catalogue_id,
          show_warehouse: true,
        }"
        @close-item="dialogItems = false"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import moment from "moment";
import ExcelJS from "exceljs";
import articles_catalogue from "@/components/Inventory/CatalogeForAdjustment.vue";
import HeaderFilters from "@/components/Inventory/HeaderFilters.vue";
import NavigationButonsTop from "@/components/Inventory/NavigationButonsTop.vue";

export default {
  data: () => ({
    employeeSelected: null,
    employeeItems: [],
    employeeSearch: "",
    loadingEmployees: false,
    employeeSearchTimeout: null,
    showBar: false,
    showHeader: false,
    filters: {
      location: { catalogue_id: "", value: "" },
      business: "",
      warehouse: { id: "", name: "" },
      dateStart: null,
      dateEnd: null,
    },
    note: "",
    reason: null,
    reason_to_filter: null,
    dialogAdjunct: false,
    refresArticles: false,
    newQuantity: 0,
    categorys: [],
    dialogItems: false,
    adjustmentDetails: [],
    isNewAdjustment: false,
    adjustments: [],
    adjustmentReasons: [],
    search: "",

    // Headers for main adjustments table
    headerArticle: [
      { text: "ID", align: "start", value: "id" },
      { text: "Nota", value: "note" },

      { text: "Usuario", value: "created_by_name" },
      { text: "Fecha", value: "effective_date" },
      { text: "", value: "show", sortable: false },
    ],

    // Headers for adjustment details table - NUEVO
    adjustmentHeaders: [
      {
        text: "Artículo",
        value: "name",
        width: "30%",
        sortable: false,
      },
      {
        text: "Cantidad Actual",
        value: "old_quantity",
        align: "center",
        width: "15%",
        sortable: false,
      },
      {
        text: "Cantidad a Despachar",
        value: "new_quantity",
        align: "center",
        width: "20%",
        sortable: false,
      },
      {
        text: "Ubicación",
        value: "warehouseInfo",
        align: "center",
        width: "15%",
        sortable: false,
      },
      {
        text: "Departamento",
        value: "department_id",
        width: "15%",
        sortable: false,
      },
      {
        text: "Acciones",
        value: "actions",
        align: "center",
        width: "5%",
        sortable: false,
      },
    ],

    departments: [],
    responsable: null,
    showAll: true,
    articleSelected: { item_name: "", available: 0 },
    rangeSelected: "3",
    dateHeader: "2022-01-01",
    defaultFilters: [],
  }),

  components: {
    articles_catalogue,
    HeaderFilters,
    NavigationButonsTop,
  },

  // ... resto del código JavaScript permanece igual
  created() {},

  mounted() {
    if (this.$route.params.id == undefined) {
      this.showHeader = true;
    }

    this.$nextTick(() => {
      if (this.$store.state.app.filters && this.$store.state.app.filters.warehouse) {
        this.filters.warehouse = this.$store.state.app.filters.warehouse;
      }
    });
  },

  computed: {
    dialogTitle() {
      if (this.filters.warehouse == undefined) {
        return "Ajuste";
      }
      if (this.isNewAdjustment == true) {
        return "Salidas de inventario - " + this.filters.warehouse.name;
      }
      return `Ajuste del ${this.filters.warehouse.name} (${this.dateHeader})`;
    },

    reasons_to_filter() {
      const reasons = Object.assign(this.adjustmentReasons, []);
      reasons.unshift({ description: "TODAS", id: 0 });
      return reasons;
    },

    reportFileName() {
      let name = "";
      if (this.filters.warehouse && this.filters.warehouse.id !== 0) {
        name = this.filters.warehouse.name;
      } else if (this.filters.location && this.filters.location.value !== 0) {
        name = this.filters.location.text;
      } else {
        name = this.filters.business_unit.name;
      }
      return `${name} desde ${this.filters.dateStart} hasta ${this.filters.dateEnd}`;
    },
  },

  methods: {
    // Método para formatear fechas usando moment
    formatDate(date) {
      if (!date) return "";
      return moment(date).format("DD/MM/YYYY hh:mm a");
    },

    onEmployeeSelected(employee) {
      // Detiene inmediatamente el estado de carga cuando se selecciona un empleado
      this.loadingEmployees = false;

      // Limpia el timeout de búsqueda si aún está pendiente
      if (this.employeeSearchTimeout) {
        clearTimeout(this.employeeSearchTimeout);
        this.employeeSearchTimeout = null;
      }

      // Si seleccionamos un empleado, actualizamos el responsable
      if (employee && employee.id) {
        // Actualizamos el responsable con el nombre del empleado
        this.responsable = employee.display_name || employee.full_name;

        // Como el campo de búsqueda y el valor seleccionado son sincronizados
        // aseguramos que el valor del campo de búsqueda se mantenga
        this.$nextTick(() => {
          // Preservamos la selección actual
          this.employeeSelected = employee;
        });

        // Guardamos en caché para futuros usos
        try {
          const cacheKey = `employee_${employee.id}`;
          localStorage.setItem(cacheKey, JSON.stringify(employee));
        } catch (e) {
          // Ignora errores de almacenamiento
        }
      } else {
        // Si se deseleccionó, limpiamos el responsable
        this.responsable = null;
      }
    },

    // Limpia los timeouts de búsqueda pendientes cuando se hace clic en el campo
    clearOldSearch() {
      // Si hay una búsqueda activa, la cancelamos
      if (this.employeeSearchTimeout) {
        clearTimeout(this.employeeSearchTimeout);
        this.employeeSearchTimeout = null;
      }

      // Detenemos el indicador de carga si estaba activo
      if (this.loadingEmployees) {
        this.loadingEmployees = false;
      }

      // Ya no limpiamos el texto de búsqueda para permitir seguir escribiendo
    },

    async searchEmployees(search) {
      // Si está intentando seleccionar un empleado, no interferimos con el proceso
      if (this.employeeSelected && !search) {
        return;
      }

      // Restablece el estado de carga si se borra la búsqueda
      if (!search) {
        this.loadingEmployees = false;
        this.employeeItems = [];
        return;
      }

      // No busca hasta tener al menos 3 caracteres
      if (search.length < 3) {
        this.employeeItems = [];
        return;
      }

      // Cancela el timeout de búsqueda anterior
      if (this.employeeSearchTimeout) {
        clearTimeout(this.employeeSearchTimeout);
        this.employeeSearchTimeout = null;
      }

      // Establece el estado de carga
      this.loadingEmployees = true;

      // Guarda el término de búsqueda actual
      const currentSearchTerm = search;

      // Busca solo después de un breve retraso para evitar llamadas API excesivas
      this.employeeSearchTimeout = setTimeout(async () => {
        try {
          // Si ya se seleccionó un empleado mientras esperábamos, no continuamos
          if (this.employeeSelected) {
            this.loadingEmployees = false;
            return;
          }

          // Verifica si la búsqueda es un número (código de empleado) o texto (nombre)
          const isEmployeeCode = /^\d+$/.test(currentSearchTerm.trim());
          let filterClause = "";

          // Busca por código de empleado o por nombre
          if (isEmployeeCode) {
            // Búsqueda solo por código de empleado
            filterClause = `AND EMPLOYEE_CODE ILIKE '%${currentSearchTerm}%'`;
          } else {
            // Maneja búsqueda por nombre - divide por espacios y crea condiciones OR para cada parte
            const nameParts = currentSearchTerm.trim().split(/\s+/);
            const nameConditions = nameParts
              .map(
                (part) =>
                  `(PERSONS.FIRSTNAME ILIKE '%${part}%' OR PERSONS.LASTNAME ILIKE '%${part}%')`
              )
              .join(" AND ");

            filterClause = `AND (${nameConditions})`;
          }

          const result = await this.api_Post("humanResource/employees/all-warehouse", {
            filters: `${filterClause}
                     ${
                       this.filters.location
                         ? "AND T.LOCATION_ID = " + this.filters.location.value
                         : ""
                     }
                     ORDER BY PERSONS.FIRSTNAME, PERSONS.LASTNAME`,
          });

          // Verificar que todavía estamos buscando lo mismo
          if (this.employeeSearch !== currentSearchTerm) {
            return; // La búsqueda ha cambiado, ignora estos resultados
          }

          // Si ya se seleccionó un empleado mientras esperábamos, no continuamos
          if (this.employeeSelected) {
            this.loadingEmployees = false;
            return;
          }

          if (result.status === 200) {
            const data = await result.json();
            // Procesar datos obtenidos
            this.employeeItems = data.map((emp) => {
              // El nombre ya viene concatenado en person_name
              const fullName = emp.person_name || "";

              return {
                ...emp,
                employee_id: emp.id,
                full_name: `${emp.employee_code} - ${fullName}`,
                display_name: fullName,
                department: emp.department_id ? `Dept: ${emp.department_id}` : "",
              };
            });
          } else {
            this.$toast.error("Error al buscar empleados");
            this.employeeItems = [];
          }
        } catch (error) {
          console.error("Error buscando empleados:", error);
          this.$toast.error("Error al buscar empleados");
          this.employeeItems = [];
        } finally {
          // Solo desactiva el estado de carga si seguimos buscando el mismo término
          if (currentSearchTerm === this.employeeSearch) {
            this.loadingEmployees = false;
          }
        }
      }, 300); // 300ms debounce
    },
    viewOutflow(id) {
      let route = this.$router.resolve({
        name: "ViewOutflows",
        params: { id: id },
      });

      window.open(route.href, "_blank");
    },

    async getDepartments(filters) {
      const response = await this.api_Get("inventory/departments/" + filters.location.id);
      const data = await response.json();
      this.departments = data;
    },

    async getAdjustments(filters) {
      // Si recibe parametros de la ventana de stock ejecuta esa consulta

      this.filters = filters;
      this.refresArticles = false;
      this.adjustments = [];

      if (filters.location.value == null) {
        return;
      }
    
      const request = await this.api_Post("inventory/get_do_outflows", {
        business_unit_id: filters.business,
        location_id: filters.location.value,
        warehouse_id: filters.warehouse.id,
        dateStart: filters.dateStart,
        dateEnd: filters.dateEnd,
      });
      const data = await request.json();

      if (request.status == 200) {
        this.adjustments = data;
      } else {
        this.$toast.error(data.error);
      }

      await this.getDepartments(this.filters);
      this.refresArticles = true;
      this.showHeader = true;
    },
    async validate_code() {
      // if (this.user.employee_code == "" || this.user.employee_code == null) {
      //   this.$toast.error("El codigo no puede estar vacio!");
      //   return;
      // }
      try {
        this.loadSearch = true;
        const result = await this.api_Post("humanResource/employees/all", {
          filters:
            " where EMPLOYEE_RECORDS_LAST_ACTION_VIEW_PERSISTENT.employee_code='" +
            this.clearInputFilter(this.user.employee_code, 6) +
            "' AND EMPLOYEE_RECORDS_LAST_ACTION_VIEW_PERSISTENT.location_id = " +
            this.filters.location.value,
        });
        const data = await result.json();
        if (result.status == 200) {
          if ((await data.length) == 0) {
            this.$toast.info("No se encontraron resultados!");
            this.loadSearch = false;
            return;
          }
          if (parseInt(data[0].employee_status_id) >= 4) {
            this.$toast.warning("Este empleado no se encuentr activo!");
            this.loadSearch = false;
            return;
          }
        } else {
          this.$toast.error(data.error);
        }
      } catch (error) {
        this.$toast.error("Error: " + error);
      }
      this.loadSearch = false;
    },
    async viewDetail(item) {
      this.dateHeader = moment(item.effective_date).format("DD/MM/YYYY HH:mm");
      this.isNewAdjustment = false;
      const request = await this.api_Get("inventory/adjustmentDetails/" + item.id);
      const data = await request.json();

      if (request.status == 200) {
        this.adjustmentDetails = data;
        this.responsable = item.use_fullname;
      } else {
        this.$toast.error(data.error);
      }

      this.dialogAdjunct = true;
    },

    newAdjustment() {
      // Intentamos usar el almacén del store si está disponible
      if (this.filters.warehouse == undefined || this.filters.warehouse.id == "") {
        if (this.$store.state.app.filters && this.$store.state.app.filters.warehouse) {
          this.filters.warehouse = this.$store.state.app.filters.warehouse;
        } else {
          // Si aún no hay almacén seleccionado, mostramos el mensaje
          this.$toast.warning("Escoja un almacen!");
          return;
        }
      }

      // Limpiamos los datos para una nueva salida
      this.note = ""; // Limpiar la nota
      this.employeeSelected = null; // Limpiar el empleado seleccionado
      this.responsable = null; // Limpiar el responsable

      this.adjustmentDetails = [];
      this.isNewAdjustment = true;
      this.dialogAdjunct = true;
    },

    addItem(item) {
      let existArticle = this.adjustmentDetails.find(
        (element) => element.item_id == item.item_id
      );

      if (existArticle != undefined) {
        this.$toast.warning(
          "Este articulo ya se encuentra en la lista, puede modificar su nueva cantidad!"
        );
      } else {
        this.adjustmentDetails.push({
          item_id: item.item_id,
          name: item.item_name,
          old_quantity: item.quantity,
          new_quantity: 0,
          quantity_difference: 0,
          warehouseInfo: item.warehouseInfo,
          department_id: null,
        });
      }
      this.dialogItems = false;
    },

    async saveAdjustment() {
      try {
        if (this.adjustmentDetails.length == 0) {
          this.$toast.warning("Agregue al menos un articulo!");
          return;
        }

        if (!this.employeeSelected) {
          this.$toast.warning("Seleccione un empleado!");
          return;
        }
        for (var item of this.adjustmentDetails) {
          item.warehouse_id = item.warehouseInfo.warehouse_id;
          item.quantity = parseFloat(item.new_quantity);
          item.note = null;
          if (item.department_id == null) {
            this.$toast.warning(
              "Seleccione un departamento para el articulo " + item.name
            );
            return;
          }
          if (item.new_quantity == 0) {
            this.$toast.warning(
              "La cantidad de diferencia debe ser mayor a 0 para el articulo " + item.name
            );
            return;
          }

          if (item.new_quantity > item.old_quantity) {
            this.$toast.warning(
              "La cantidad nueva debe ser menor a la cantidad anterior para el articulo " +
                item.name
            );
            return;
          }
        }
        const request = await this.api_Post("inventory/do_outflow", {
          business_unit_id: this.filters.business,
          location_id: this.filters.location.value,
          created_by: this.$store.state.auth.user.user.user_id,
          //warehouse_id: this.filters.warehouse.id,
          note: this.note == "" ? null : this.note,
          item_details: this.adjustmentDetails,
          employee_id: this.employeeSelected.employee_id,
        });
        const data = await request.json();

        if (request.status == 200) {
          this.$toast.success("Registrado correctamente!");
          this.getAdjustments(this.filters);
          this.note = "";
          this.dialogAdjunct = false;
        } else {
          this.$toast.error(data.error);
        }
      } catch (error) {
        console.error(error);
      }
    },

    itemDetailDifferent(item) {
      return parseFloat(item.new_quantity) - parseFloat(item.old_quantity);
    },

    removeItem(item) {
      let indice = this.adjustmentDetails.indexOf(item);
      this.adjustmentDetails.splice(indice, 1);
    },

    backToInventoryValue() {
      this.$router.push({
        name: "InventoryManagement",
        params: {
          filtersDefault: this.filters,
        },
      });
    },

    onClickOutside() {
      this.showBar = false;
    },

    async resume_report() {
      // Crear un nuevo libro de Excel y una hoja
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Ajustes");

      // Definir encabezados
      worksheet.columns = [
        { header: "ID", key: "id", width: 10 },
        { header: "Ubicación", key: "location", width: 20 },
        { header: "Almacén", key: "warehouse", width: 20 },
        { header: "Fecha Efectiva", key: "effective_date", width: 20 },
        { header: "Razón", key: "reason", width: 30 },
        { header: "Monto", key: "accounting_amount", width: 15 },
        { header: "Nota", key: "note", width: 50 },
        { header: "Usuario", key: "use_fullname", width: 20 },
      ];

      // Agregar datos a la hoja

      // Estilizar encabezados
      worksheet.getRow(1).eachCell((cell) => {
        cell.font = { bold: true };
        cell.alignment = { horizontal: "center" };
      });

      // Generar el archivo Excel
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: "application/octet-stream" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `Reporte resumido de ajustes ${this.reportFileName}.xlsx`;
      link.click();
    },

    async detail_report() {
      try {
        const request = await this.api_Post("inventory/adjustment_detail_report", {
          business_unit_id: this.filters.business,
          location_id: this.filters.location.value,
          warehouse_id: this.filters.warehouse.id,
          dateStart: this.filters.dateStart,
          dateEnd: this.filters.dateEnd,
          reason_id: this.reason_to_filter.id,
        });
        const data = await request.json();

        if (request.status != 200) {
          this.$toast.error(data.error);
          return;
        }

        // Crear un nuevo libro de Excel y una hoja
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Ajustes Inventario");

        // Definir encabezados
        worksheet.columns = [
          { header: "Unidad de Negocio", key: "business_unit_description", width: 20 },
          { header: "Ubicación", key: "location_description", width: 20 },
          { header: "Almacén", key: "warehouse_name", width: 20 },
          { header: "Razon", key: "ajustment_description", width: 25 },
          { header: "Fecha", key: "effective_date", width: 20 },
          { header: "ID del Ítem", key: "item_id", width: 10 },
          { header: "Ítem", key: "name", width: 25 },
          { header: "Nota", key: "note", width: 50 },
          { header: "Cantidad Actual", key: "old_quantity", width: 15 },
          { header: "Cantidad Nueva", key: "new_quantity", width: 15 },
          { header: "Diferencia", key: "quantity_difference", width: 15 },
          { header: "Monto", key: "accounting_amount", width: 15 },
        ];

        // Agregar datos a la hoja
        data.forEach((item) => {
          worksheet.addRow({
            business_unit_description: item.business_unit_description,
            location_description: item.location_description,
            warehouse_name: item.warehouse_name,
            ajustment_description: item.ajustment_description,
            effective_date: new Date(item.effective_date).toLocaleString(),
            item_id: item.item_id,
            name: item.name,
            note: item.note,
            old_quantity: item.old_quantity,
            new_quantity: item.new_quantity,
            quantity_difference: item.quantity_difference,
            accounting_amount: parseFloat(item.accounting_amount).toFixed(2),
          });
        });

        // Estilizar encabezados
        worksheet.getRow(1).eachCell((cell) => {
          cell.font = { bold: true };
          cell.alignment = { horizontal: "center" };
        });

        // Generar el archivo Excel
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: "application/octet-stream" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `Reporte detallado de ajustes ${this.reportFileName}.xlsx`;
        link.click();
      } catch (error) {
        console.error(error.message);
      }
    },

    async print() {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Items");

      // Agregar columnas
      worksheet.columns = [
        { header: "Item ID", key: "item_id", width: 10 },
        { header: "Nombre", key: "name", width: 30 },
        { header: "Almacen", key: "warehouse", width: 15 },
        { header: "Cantidad actual", key: "old_quantity", width: 20 },
        { header: "Cantidad a despachar", key: "new_quantity", width: 20 },
      ];

      // Agregar filas
      this.adjustmentDetails.forEach((item) => {
        worksheet.addRow({
          item_id: item.item_id,
          name: item.name,
          warehouse: item.warehouseInfo?.warehouse_name || "N/A",
          old_quantity: item.old_quantity,
          new_quantity: item.new_quantity,
        });
      });

      // Generar el archivo como blob para navegador
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: "application/octet-stream" });

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `Ajuste de inventario ${moment().format(
        "DD-MM-YYYY hh-mm-ss"
      )}.xlsx`;
      link.click();
    },

    // Método auxiliar para formatear números como moneda
    currencyFormat(value) {
      if (!value) return "0.00";
      return parseFloat(value).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    // Método auxiliar para padding de números
    filLeft(str, length, char) {
      return str.padStart(length, char);
    },
  },
};
</script>

<style scoped>
.hover-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

.cursor-pointer {
  cursor: pointer;
}

/* Estilos adicionales para mejorar la apariencia */
.v-data-table >>> .v-data-table__wrapper {
  border-radius: 8px;
}

.v-chip.v-size--small {
  font-size: 12px;
}

.v-list-item {
  min-height: 45px;
}

/* Enhanced loading state styles */
.v-autocomplete__content.v-menu__content {
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2) !important;
  border-radius: 4px;
  margin-top: 4px;
}

.v-autocomplete__menu .v-progress-circular {
  margin: 20px auto;
  width: 40px !important;
  height: 40px !important;
}

.v-autocomplete__menu .v-progress-circular__indeterminate {
  color: #4caf50 !important;
}

.v-autocomplete__menu .v-progress-circular__overlay {
  color: rgba(76, 175, 80, 0.2);
}

.v-autocomplete__menu .v-list {
  padding: 8px 0;
}

.v-autocomplete__menu .v-list-item {
  min-height: 48px;
  padding: 0 16px;
}

.v-autocomplete__menu .v-list-item__title {
  font-weight: 500;
  color: #333;
}

.v-autocomplete__menu .v-list-item__subtitle {
  color: #666;
  font-size: 0.8rem;
}

/* Pulse animation for loading text */
@keyframes pulse {
  0% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.5;
  }
}

.loading-text {
  display: flex;
  justify-content: center;
  padding: 16px;
  color: #4caf50;
  font-weight: 500;
  animation: pulse 1.5s infinite;
}
</style>
